import React from "reactn";
import { BoxForm } from "../../../../components/UI/form";
import axios from "axios";

class SectionSix extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { days: {}, accountStatus: null };
  }

  async componentDidMount() {
     const stripeId = this.global.organizationInfo?.stripeId;
     if (!stripeId) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/stripe/account-status/${stripeId}`
      );
      if (res.data?.success) {
        this.setState({ accountStatus: res.data.data });
      }
    } catch (e) {
      // ignore, default to showing Resume Setup
    }
  }

  handleChange = (e, v) => {
    this.setGlobal({
      organizationInfo: {
        ...this.global.organizationInfo,
        [e]: v
      }
    });
  };

  updateBankAccount = async () => {
    const ep = `${process.env.REACT_APP_API}/partners/organization_profile/update-bank`;
    const results = await axios.post(ep);

    if (results.data.success) {
      window.open(results.data.data.url);
    }
  };
 //not used anymore
  generateState = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  };

  customForm = () => {
    const stripeId = this.global.organizationInfo?.stripeId;
    const status = this.state.accountStatus;
    const isFullyOnboarded =
      status && status.detailsSubmitted && status.payoutsEnabled;
    return (
      <div className="formbody">
        <form>
          <div className="row">
            <div className="col-12">
              <h3>
                If you want to opt-in to receive payment electronically via
                Dreamschools. Please link your bank account below.
              </h3>
            </div>
            <div className="col-12 d-flex" style={{ justifyContent: "center" }}>
              {!stripeId ?(
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={async _ => {
                    const res = await axios.post(`${process.env.REACT_APP_API}/partners/organization_profile/stripe`);
                    if (res.data.success) window.location.href = res.data.data.accountLinkUrl;
                  }}
                  disabled={this.global.organizationInfo.manual_payments}
                >
                  Link my bank account!
                </button>
                ) : !isFullyOnboarded ? (
                  <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={async _ => {
                    const res = await axios.post(`${process.env.REACT_APP_API}/partners/organization_profile/stripe`);
                    if (res.data.success) window.location.href = res.data.data.accountLinkUrl;
                  }}
                  >
                  Resume Stripe Setup
                  </button>
                  ) : (
                  <>
                  <h2 style={{ paddingRight: '25px', paddingLeft: '25px' }}>
                    Bank Account Linked!
                  </h2>
                  </>
              )}
            </div>
            <div className="col-12 d-flex" style={{ justifyContent: "center" }}>
              {stripeId && isFullyOnboarded && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={_ => this.updateBankAccount()}
                >
                  Update bank account!
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    );
  };

  render() {
    return (
      <BoxForm
        handleChange={this.handleChange}
        name={"Link your bank account!"}
        customForm={this.customForm()}
      />
    );
  }
}

export default SectionSix;
